<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-wsn-flybook-full-col`]" width="1em" height="1em" v-bind="$attrs"><g transform="translate(10 10)" fill="none" fill-rule="evenodd"><path stroke="#009688" stroke-width="5" d="M57.913 90.884L104.243 13.833"/><path d="M99.7922432 6.26553402L52.2486443 58.0200093 23.5869311 56.6064179 3.64064569 34.944934 99.7922432 6.26553402zM106.901516 7.42393687L77.5698927 110.228363 56.7316222 89.9134237 55.1317648 60.5843308 106.901516 7.42393687z" stroke="#009688" stroke-width="4"/><path :fill="useCurrentColor ? 'currentColor' : '#00D1AB'" d="M22.670429 58.5636472L53.0869565 60.0637857 105.801917 2.27498464z"/><path :fill="useCurrentColor ? 'currentColor' : '#44ECD8'" d="M106.173913 2.27498464L0 33.9437681 22.670429 58.5636472z"/><path :fill="useCurrentColor ? 'currentColor' : '#015FEF'" d="M53.0869565 60.0637857L54.699394 90.8844796 111 0.348691267z"/><path :fill="useCurrentColor ? 'currentColor' : '#3885FF'" d="M54.699394 90.8844796L78.5736008 114 111 0.348691267z"/><ellipse :fill="useCurrentColor ? 'currentColor' : '#FFF'" cx="78.183" cy="33.096" rx="4.826" ry="4.816"/><path :fill="useCurrentColor ? 'currentColor' : '#FFF'" d="M77.2173913 29.5708805L108.554496 0 111 0.348691267 81.2631383 33.0956785z"/></g></svg>
</template>
<script>

export default {
  name: 'IconWsnFlybookFullCol',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
